import React from "react"
import { appName, appSlogan, } from "../../../constants"

import "./Footer.scss"

function Footer() {
  return (
    <footer className="footer">
      <div className="container-fluid">
        <nav className="pull-left">
          <ul className="nav">
            <li className="nav-item">
              <a className="nav-link" href={process.env.REACT_APP_WEB_JOYSTICK_ROOT_URL}>
                {appName}
              </a>
            </li>
            <li className="nav-item list-item-no-link">
              {appSlogan}
            </li>
          </ul>
        </nav>
        <div className="ms-auto">
          <a href="/privacy-policy">
            Privacy Policy
          </a>
        </div>
        <div className="copyright ms-auto">
          2026
        </div>
      </div>
    </footer>
  )
}

export default Footer